import {GET_NEWS_DETAIL_ERROR, GET_NEWS_DETAIL_START, GET_NEWS_DETAIL_SUCCESS} from "../../types";

export default function news_detail(state, action) {
  switch (action.type) {
    case GET_NEWS_DETAIL_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_NEWS_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_NEWS_DETAIL_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
    }
}
